// extracted by mini-css-extract-plugin
export default {"filterRow":"PhoneFilter_filterRow__3g8HP","Button":"PhoneFilter_Button__lBks2","Title":"PhoneFilter_Title__svWbc","Text":"PhoneFilter_Text__qByjz"};